import { useState, useEffect } from "react";
import "./youtube.css";

const Youtubeapi = () => {
  const [youTubeVideos, setVideo] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

    fetch(
      `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=9&type=video&q=Apple&key=${API_KEY}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`YouTube API error: ${response.status}`);
        }

        return response.json();
      })
      .then((data) => {
        console.log("YouTube API response:", data);

        if (data.error) {
          throw new Error(
            data.error.message || "YouTube API request failed"
          );
        }

        setVideo(data.items || []);
      })
      .catch((err) => {
        console.error("YouTube API Error:", err);
        setError(err.message);
        setVideo([]);
      });
  }, []);

  console.log("YouTube videos:", youTubeVideos);

  return (
    <div className="allVideosWrapper">
      <div className="container">
        <div className="row h-100 align-items-center justify-content-center text-center">

          <div className="col-12">
            <br />
            <br />

            <div className="title-wraper bold video-title-wrapper">
              Latest Videos
            </div>

            <br />
            <br />
          </div>

          {error && (
            <div className="col-12">
              <p>Unable to load videos: {error}</p>
            </div>
          )}

          {!error &&
            youTubeVideos.map((singleVideo, i) => {
              const vidId = singleVideo.id.videoId;

              const vidLink = `https://www.youtube.com/watch?v=${vidId}`;

              return (
                <div
                  key={i}
                  className="col-sm-12 col-md-6 col-lg-4"
                >
                  <div className="singleVideoWrapper">

                    <div className="videoThumbnail">
                      <a
                        href={vidLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={singleVideo.snippet.thumbnails.high.url}
                          alt={singleVideo.snippet.title}
                        />
                      </a>
                    </div>

                    <div className="videoInfoWrapper">

                      <div className="videoTitle">
                        <a
                          href={vidLink}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {singleVideo.snippet.title}
                        </a>
                      </div>

                      <div className="videoDesc">
                        {singleVideo.snippet.description}
                      </div>

                    </div>
                  </div>
                </div>
              );
            })}

        </div>
      </div>
    </div>
  );
};

export default Youtubeapi;